var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 54,
    viewBox: "0 0 42 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5_6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 49.5,
    rx: 7,
    ry: 2.5,
    fill: "black",
    fillOpacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 0C32.598 0 42 9.40202 42 21C42 29.8926 36.4727 37.4942 28.6663 40.5567L22.1961 49.4007C22.0612 49.5858 21.8821 49.7369 21.6739 49.8412C21.4657 49.9455 21.2346 50 21 50C20.7654 50 20.5343 49.9455 20.3261 49.8412C20.1179 49.7369 19.9388 49.5858 19.8039 49.4007L13.3337 40.5567C5.52726 37.4941 0 29.8926 0 21C0 9.40202 9.40202 0 21 0Z",
    fill: "#80BC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21C30 16.0294 25.9706 12 21 12C16.0294 12 12 16.0294 12 21C12 25.9706 16.0294 30 21 30C25.9706 30 30 25.9706 30 21Z",
    fill: "#5A8400"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5_6",
    x: 12,
    y: 45,
    width: 18,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5_6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.178951137118521d1a94bbc9d9901460.svg";
export { ForwardRef as ReactComponent };